import { render, staticRenderFns } from "./ListPlaceholder.vue?vue&type=template&id=03bb09b8&scoped=true&"
import script from "./ListPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ListPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ListPlaceholder.vue?vue&type=style&index=0&id=03bb09b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bb09b8",
  null
  
)

export default component.exports